var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "ui-toolbar",
        { staticClass: "ui-toolbar ui-elevation-1", attrs: { dense: "" } },
        [
          _vm.user.recorder
            ? _c(
                "span",
                {
                  staticClass: "ui-toolbar__recorder",
                  attrs: {
                    title:
                      "You may call " +
                      _vm.user.recorder.uri +
                      " from your video system or platform to start a recording or streaming session",
                  },
                },
                [
                  _vm._v("\n\t\t\tYour address: "),
                  _c("strong", [_vm._v(_vm._s(_vm.user.recorder.uri))]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ui-toolbar-section-end" },
            [
              _c(
                "ui-menu",
                { attrs: { icon: "fa fa-bars", size: "medium" } },
                [
                  _vm.isAdmin
                    ? _c("ui-menu-item", {
                        attrs: { icon: "fal fa-user-shield", label: "Admin" },
                        on: {
                          click: function ($event) {
                            return _vm.openTab("/adm")
                          },
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("ui-menu-item", {
                    attrs: { icon: "fal fa-newspaper", label: "News" },
                    on: {
                      click: function ($event) {
                        return _vm.openTab("/news")
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("ui-menu-item", {
                    attrs: { icon: "fal fa-question-circle", label: "Help" },
                    on: {
                      click: function ($event) {
                        return _vm.openTab("/help")
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("ui-menu-item", {
                    attrs: { icon: "fal fa-envelope", label: "Support" },
                    on: {
                      click: function ($event) {
                        return _vm.$refs.feedbackDialog.open()
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("ui-menu-item", {
                    attrs: { icon: "fal fa-user-cog", label: "Profile" },
                    on: {
                      click: function ($event) {
                        return _vm.$refs.profileDialog.open()
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("ui-menu-item", {
                    attrs: { icon: "fal fa-database", label: "Storage" },
                    on: {
                      click: function ($event) {
                        return _vm.$refs.storageDialog.open()
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("ui-menu-item", {
                    attrs: { icon: "fal fa-cog", label: "Settings" },
                    on: {
                      click: function ($event) {
                        return _vm.$refs.settingsDialog.open()
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("ui-menu-item", {
                    attrs: { icon: "fal fa-sign-out-alt", label: "Logout" },
                    on: { click: _vm.logout },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("feedback-dialog", { ref: "feedbackDialog" }),
      _vm._v(" "),
      _c("profile-dialog", { ref: "profileDialog", attrs: { user: _vm.user } }),
      _vm._v(" "),
      _c("storage-dialog", {
        ref: "storageDialog",
        attrs: { recorder: _vm.user.recorder },
      }),
      _vm._v(" "),
      _c("settings-dialog", {
        ref: "settingsDialog",
        attrs: { recorder: _vm.user.recorder },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }